import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<Saas::IsSquareOneEligible>\n  <Staff::StaffMount @bundle=\"subscriptionNullStates\" />\n</Saas::IsSquareOneEligible>\n<Saas::IsSquareOneIneligible>\n  {{yield}}\n</Saas::IsSquareOneIneligible>", {
  moduleName: "@dashboard/shared-ui/components/staff/subscription-null-states.hbs"
});